/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useContext} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_LOGOUT, API_UPLOADS, API_SCT, API_URL, API_SERVER } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useHistory, useLocation, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {decode} from 'html-entities';
import {reactLocalStorage} from 'reactjs-localstorage';
import Tour from 'reactour'
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Context]
-------------------------------------------------------------------*/
import { UserContext, NotificationContext, LocationContext } from '../../../context/container'
/*------------------------------------------------------------------
[End Context]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Redux]
-------------------------------------------------------------------*/
import {useSelector, useDispatch} from 'react-redux';
import { _action_user } from '../../../redux/store';
/*------------------------------------------------------------------
[End Redux]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Loading]
-------------------------------------------------------------------*/
import ReactLoading from 'react-loading';
/*------------------------------------------------------------------
[End Loading]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Route JSON]
-------------------------------------------------------------------*/
import { route } from "./@api.json";
/*------------------------------------------------------------------
[End Route JSON]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev, YEAR } from "../../../functions";
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Sub Screen]
-------------------------------------------------------------------*/
import Admin from './admin'
import Payment from './payment'
import Location from './location'
import MasterLocationCategory from './master_location_category'
/*------------------------------------------------------------------
[End Sub Screen]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Style]
-------------------------------------------------------------------*/
import '../../../style/general/node.entry.css';
import '../../../style/admin/node.admin.css';
/*------------------------------------------------------------------
[End Style]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import OverlayBg from '../../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress, setting, fmc_token}) => {

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [useLocation]
    ----------------------------------------------------------------*/
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery();
    /*--------------------------------------------------------------
    [End useLocation]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [tour, set_tour] = useState(false);

	const [loading_stuck, set_loading_stuck] = useState(false);
    const [refresh, set_refresh] = useState(null);
    const [file, set_file] = useState(null);

    const [bamboo_user, set_bamboo_user] = useState('');
    const [bamboo_update, set_bamboo_update] = useState('');
    const [path_client, set_path_client] = useState('');

    const [bubble_active, set_bubble_active] = useState('_bb-bubble');
    const [bubble_active_top, set_bubble_active_top] = useState('_bb-bubble-top');
    const [bubble_active_left, set_bubble_active_left] = useState('_bb-bubble-left');
    const [bubble_active_top_link, set_bubble_active_top_link] = useState('_bb-tooltip _bb-tooltip-left');
    const [bubble_active_left_link, set_bubble_active_left_link] = useState('_bb-tooltip _bb-tooltip-top');

    const [toggle, set_toggle] = useState('_toggle');
    const [sidebar, set_sidebar] = useState('_sidebar');
    const [overlay_close, set_overlay_close] = useState(false);

    const [routes, set_routes] = useState('home');

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);

    const [data, set_data] = useState(null);
    const [search, set_search] = useState('');

    const [name, set_name] = useState('');
    const [address, set_address] = useState('');
    const [no_hp, set_no_hp] = useState('');
    const [password, set_password] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/
    const steps = [
        {
          selector: '.___selector',
          content: 'Desc',
        },
    ];
    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Redux]
    ----------------------------------------------------------------*/
	const dispatch = useDispatch();

    const redux_user = useSelector(state => state.user);

	const _set_redux_user = (data) => {
		dispatch(_action_user(data, 'data'))
	}
    /*--------------------------------------------------------------
    [End Redux]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Context]
    ----------------------------------------------------------------*/
    const { user, set_user } = useContext(UserContext);
    const { notification, set_notification } = useContext(NotificationContext);
    const { location, set_location } = useContext(LocationContext);
    /*--------------------------------------------------------------
    [End Context]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _logout = () => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_LOGOUT(`${route}/logout__________`)
        .then((response) => {
			console.log('logout : ', response.data)
            if(response.data.result === 'success'){
                history.push(`/${route}/home`)
                _socket_offline()
                set_location('client')
                set_user('public')
                reactLocalStorage.clear();
                set_loading_stuck(false)
            }else if(response.data.error){
                if(response.data.error === 'Token Denied'){
                    set_location('client')
                    set_user('public')
                    reactLocalStorage.clear();
                    set_loading_stuck(false)
                }else{
                    error(response.data.error)
                }
            }else{
                error('Error Server')
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
		})
        
    }

    const _uploads = (action) => {

        if(loading === true){
            return
        }

        loading(true);

        console.log('action :', action)
        console.log('key    :', STORAGE_USER[0].id_key)

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("bamboo_user", bamboo_user);
        data.append("path_client", path_client);
        data.append("action", action);
        // new request --------------------------------
        data.append("name", name);
        data.append("location", address);
        data.append("no_hp", no_hp);
        data.append("password", password);

        if(file !== null){
            file.map((item) => (
                data.append("file", item)
            ))
        }

        var config = {
            method: 'post',
            url: API_URL + `${route}/user/post__________`,
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(file !== null){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
            }
        };

        axios(config)
        .then((response) => {
            console_dev(`response uploads`, response.data)
            if(response.data.result === 'success'){
                set_password('')
                STORAGE_USER = response.data.data.user
                reactLocalStorage.set('@user', JSON.stringify(response.data.data.user));
                error(response.data.title)
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console_dev('catch', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
		})

    }

    const _fmc_token = (bambooUserParams) => {

        if(loading === true){
            return
        }

		loading(true);

        API_POST(`${route}/notification/post__________`, {
            action: 'update_fmc_token',
            bamboo: bambooUserParams,
            fmc_token: fmc_token
        })
        .then((response) => {
            if(response.data.result === 'success'){
                
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

    }
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Socket]
    ----------------------------------------------------------------*/
    const _socket_online = (storageUserParams) => {

        // socket.on(`${route}_user_authentication`, (data) => {
		// 	console.log(`${route}_user_authentication : `, data)	
		// })

        // socket.emit(`${route}_user_authentication`, {
        //     action: 'connect',
        //     room: `room_${route}_user_authentication`,
        //     status: 'online',
        //     bamboo_user : storageUserParams.bamboo,
        //     username : storageUserParams.username,
        //     name : storageUserParams.name,
        //     url_photo : storageUserParams.path + '/' + storageUserParams.photo,
        //     e_account : storageUserParams.e_account,
        // });
		
	}
    const _socket_offline = () => {

        // socket.on(`${route}_user_authentication`, (data) => {
		// 	console.log(`${route}_user_authentication : `, data)	
		// })

        socket.emit(`${route}_user_authentication`, {
            action: 'disconnect',
            room: `room_${route}_user_authentication`,
            status: 'offline',
            bamboo_user : STORAGE_USER[0].bamboo,
            username : STORAGE_USER[0].username,
            name : STORAGE_USER[0].name,
            url_photo : STORAGE_USER[0].path + '/' + STORAGE_USER[0].photo,
            e_account : STORAGE_USER[0].e_account,
        });

    }
    /*--------------------------------------------------------------
    [End Socket]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _bubble = () => {
        if(bubble_active === '_bb-bubble'){
            set_bubble_active('_bb-bubble _bb-bubble-active')
            set_bubble_active_top('_bb-bubble-top _bb-bubble-show')
            set_bubble_active_left('_bb-bubble-left _bb-bubble-show')

            set_bubble_active_top_link('_bb-tooltip _bb-tooltip-left _bb-bubble-show')
            set_bubble_active_left_link('_bb-tooltip _bb-tooltip-top _bb-bubble-show')
        }else{
            set_bubble_active('_bb-bubble')
            set_bubble_active_top('_bb-bubble-top')
            set_bubble_active_left('_bb-bubble-left')
            
            set_bubble_active_top_link('_bb-tooltip _bb-tooltip-left')
            set_bubble_active_left_link('_bb-tooltip _bb-tooltip-top')
        }
    }

    const _toggle = () => {

        if(toggle === '_sidebar'){
            set_toggle(false)
            set_sidebar('_sidebar')
            set_overlay_close(false);
        }else{
            set_toggle(true)
            set_sidebar('_sidebar _active')
            set_overlay_close(true);
        }

    }

    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    if(STORAGE_USER !== undefined){
        if(STORAGE_USER[0].level === 'guest'){
            history.push('/')
            set_location('public')
        }
    }else{
        history.push('/home')
    }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        let storage_bamboo = STORAGE_USER[0].bamboo;
        
        if(storage_bamboo){
            set_bamboo_user(storage_bamboo)
            _socket_online(STORAGE_USER[0])
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        _STORAGE_USER()
        
        setTimeout(() => {
            
            set_loading_stuck(true) 
            
        }, 2500);

        set_location(history.location.pathname)

        // if(query.get("route") === 'transaction'){
        //     set_routes(`${route}/transaction`)
        // }

    }, [refresh])

    useEffect(() => {

        if(bamboo_user && fmc_token){
            _fmc_token(bamboo_user)
        }

    }, [bamboo_user, fmc_token])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Render]
    ----------------------------------------------------------------*/
    return (
        
        <>

            <Tour steps={steps} isOpen={tour} onRequestClose={() => set_tour(false)}/>
            <Tour disableKeyboardNavigation={['esc']} />

            {

                !loading_stuck &&
                <div className="_app_loading">
                    <div className="_position_middle">
                        <ReactLoading type={'cylon'} color={'#222'} height={50} width={50} />
                        <h2 style={{marginBottom: 6}}><span style={{color: '#118ab2'}}>e-</span>Configuration</h2>
                        <p>Saving Data . . .</p>
                    </div>				
                </div>	
            }

            <div className="_bb-background" style={{backgroundImage: `url(${API_UPLOADS + setting.background})`}}></div>
            
            <div className="_bb-position-overlay">

                {
                    overlay_close &&
                    <div onClick={() => {
                        set_sidebar('_sidebar')
                        set_overlay_close(false);
                    }} style={{position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10}}>

                    </div>
                }
                <div className={sidebar}>
                    <div className="_header">
                        {
                            STORAGE_USER &&
                            <>

                                <div className="_profile">
                                    <p className="_position_middle" style={{fontSize: 60}}>{STORAGE_USER[0].username.charAt(0)}</p>
                                    <div className="_profile_upload" onClick={() => {
                                            set_bamboo_update(STORAGE_USER[0].bamboo)
                                            set_path_client(STORAGE_USER[0].path)
                                            set_name(STORAGE_USER[0].name)
                                            set_address(STORAGE_USER[0].location)
                                            set_no_hp(STORAGE_USER[0].no_hp)
                                        }}>
                                        <ion-icon name="pencil-outline"></ion-icon>
                                    </div>
                                </div>
                                <div className="_push_t_s">
                                    <p className="_center_text" style={{maxWidth: 200, margin: 'auto'}}>{STORAGE_USER[0].name}</p>
                                </div>

                                {/* <p className="_push_t_s">{STORAGE_USER[0].username}</p> */}

                            </>
                        }
                    </div>
                    <div className="_lily_pad_v_m">
                        <div onClick={() => {
                            set_element(null)
                            set_routes('home')
                        }} className="_link_hooks _cursor_pointer">
                            <div className="_row _center_align">
                                <div className="_push_r_m">
                                    <ion-icon name="home-outline" style={{color: routes === 'home' ? '#118ab2' : 'inherit', fontSize: 20}}></ion-icon>
                                </div>
                                <div className="_column" style={{color: routes === 'home' ? '#118ab2' : 'inherit'}}>
                                    Home
                                </div>
                            </div>
                        </div>
                        
                        {
                            user && user[0].level === 'admin' &&
                            <>
                                <div onClick={() => {
                                    if(element === 'master_data'){
                                        set_element(null)
                                    }else{
                                        set_element('master_data')
                                    }
                                }} className="_link_hooks _cursor_pointer _relative ___step_master_data">
                                    <div style={{position: 'absolute', left: 4, top: 13}}>
                                        {
                                            element === 'master_data' ?
                                                <ion-icon name="caret-down-outline" style={{fontSize: 12, color: '#999'}}></ion-icon>
                                            :
                                                <ion-icon name="caret-forward-outline" style={{fontSize: 12, color: '#999'}}></ion-icon>
                                        }
                                    </div>
                                    <div className="_row _center_align">
                                        <div className="_push_r_m">
                                            <ion-icon name="albums-outline" style={{fontSize: 20}}></ion-icon>
                                        </div>
                                        <div className="_column">
                                            Master Data
                                        </div>
                                    </div>
                                </div>
                                {
                                    element === 'master_data' &&
                                    <>
                                        <div onClick={() => set_routes(`${route}/master/location/category`)} className="_link_hooks _cursor_pointer _relative">
                                            <div className="_row _center_align">
                                                <div className="_push_r_m">
                                                    <ion-icon name="ellipse-outline" style={{color: routes === `${route}/master/dropdown` ? '#118ab2' : 'inherit', fontSize: 20}}></ion-icon>
                                                </div>
                                                <div className="_column" style={{color: routes === `${route}/master/mata_pelajaran` ? '#118ab2' : 'inherit'}}>
                                                   Location Category
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </>
                        }

                        {
                            user && user[0].level === 'admin' &&
                            <div onClick={() => {
                                set_element(null)
                                set_routes(`${route}/location`)
                            }} className="_link_hooks _cursor_pointer">
                                <div className="_row _center_align">
                                    <div className="_push_r_m">
                                        <ion-icon name="location-outline" style={{color: routes === `${route}/location` ? '#118ab2' : 'inherit', fontSize: 20}}></ion-icon>
                                    </div>
                                    <div className="_column" style={{color: routes === `${route}/location` ? '#118ab2' : 'inherit'}}>
                                        Location
                                    </div>
                                </div>
                            </div>
                        }

                        {/* {
                            user && user[0].level === 'admin' &&
                            <div style={{borderWidth: 1, borderColor: '#eee', borderRightWidth: 0, borderLeftWidth: 0, borderStyle: 'solid', padding: 20, paddingTop: 10, paddingBottom: 10, marginTop: 10, marginBottom: 10}}>
                                Tour Guide
                            </div>
                        }

                        {
                            user && user[0].level === 'admin' &&
                            <div onClick={() => {
                                set_tour(true)
                            }} className="_link_hooks _cursor_pointer ___step_menu_guide">
                                <div className="_row _center_align">
                                    <div className="_push_r_m">
                                        <ion-icon name="footsteps-outline" style={{color: 'inherit', fontSize: 20}}></ion-icon>
                                    </div>
                                    <div className="_column" style={{color: 'inherit'}}>
                                        Menu Guide
                                    </div>
                                </div>
                            </div>
                        } */}

                        <div style={{borderWidth: 1, borderColor: '#eee', borderRightWidth: 0, borderLeftWidth: 0, borderStyle: 'solid', padding: 20, paddingTop: 10, paddingBottom: 10, marginTop: 10, marginBottom: 10}}>
                            System
                        </div>

                        <div onClick={() => _logout()} className="_link_hooks _cursor_pointer ___step_logout">
                            <div className="_row _center_align">
                                <div className="_push_r_m">
                                    <ion-icon name="log-out-outline" style={{color: 'inherit', fontSize: 20}}></ion-icon>
                                </div>
                                <div className="_column">
                                    Logout
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="_content">

                    <div style={{position: 'absolute', top: 18, right: 20, zIndex: 1}} className="_toggle_sidebar" onClick={() => _toggle()}>
                        <ion-icon name="menu-outline"></ion-icon>
                    </div>

                    {
                        bamboo_update.length > 0 &&
                        <>
                            <div className="_bb_modal_overlay">
                                <div className="_bb_modal_nav">
                                    <div className="_row _center_align">
                                        <div className="_column">
                                            <h3>Perbaharui Data</h3>
                                        </div>
                                        <div onClick={() =>
                                            {
                                                set_bamboo_update('')
                                                set_path_client('')
                                                set_refresh(random_character(16))
                                                set_routes('home')
                                            } 
                                        }  className="_btn _cursor_pointer" style={{backgroundColor: '#fff', borderColor: '#eee'}}>
                                            Keluar
                                        </div>
                                    </div>
                                </div>
                                <div style={{borderWidth: 1, borderColor: '#eee', borderBottomStyle: 'solid'}} />
                                <div className="_bb_modal_body">
                                    <div className="_container">
                                        <div className="_lily_pad_h_d">
                                            <div className="_row _push_t_g _push_b_g">
                                                <div className="_column">
                                                    <div className="_heading_bold _push_b_d">
                                                        Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                                                    </div>
                                                    <div className="_relative _push_b_d">
                                                        <p style={{color: '#888', fontSize: 13}}>
                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                            Photo
                                                        </p>
                                                    </div>
                                                    <div className="_row _push_b_d">
                                                        <div className="_column _push_r_d">
                                                            <div className="_bb-input _push_b_d" style={{marginTop: -16}}>
                                                                <div className="_e_input">
                                                                    <input
                                                                        className="custom-file-input" 
                                                                        type="file"
                                                                        name="file"
                                                                        placeholder=""
                                                                        onChange={_files}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {
                                                            STORAGE_USER !== undefined &&
                                                            <div style={{marginTop: -8, height: 70, width: 70, borderRadius: 70, backgroundColor: '#eee', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundImage: `url(${API_SERVER}/${STORAGE_USER[0].path}/${STORAGE_USER[0].photo})`}} >

                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="_relative _push_b_d">
                                                        <p style={{color: '#888', fontSize: 13}}>
                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                            Name
                                                        </p>
                                                        <div className="_e_input">
                                                            <input 
                                                                placeholder=""
                                                                type={'text'} 
                                                                onChange={e => set_name(e.target.value)}
                                                                value={name}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="_relative _push_b_d">
                                                        <p style={{color: '#888', fontSize: 13}}>
                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                            Address
                                                        </p>
                                                        <div className="_e_input">
                                                            <input 
                                                                placeholder=""
                                                                type={'text'} 
                                                                onChange={e => set_address(e.target.value)}
                                                                value={address}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="_relative _push_b_d">
                                                        <p style={{color: '#888', fontSize: 13}}>
                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                            No.Hp
                                                        </p>
                                                        <div className="_e_input">
                                                            <input 
                                                                placeholder=""
                                                                type={'text'} 
                                                                onChange={e => set_no_hp(e.target.value)}
                                                                value={no_hp}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="_relative _push_b_d">
                                                        <p style={{color: '#888', fontSize: 13}}>
                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                            Password
                                                        </p>
                                                        <div className="_e_input">
                                                            <input 
                                                                placeholder=""
                                                                type={'password'} 
                                                                onChange={e => set_password(e.target.value)}
                                                                value={password}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div onClick={() => {
                                                        if(file === null){
                                                            _uploads('update_user_text')
                                                        }else{
                                                            _uploads('update_user_file')
                                                        }
                                                    }} className="_btn _cursor_pointer">
                                                        Simpan
                                                    </div>
                                                </div>
                                                <div className="_fmc_overlay_bg_hide">
                                                    <img style={{width: 400}} src={OverlayBg}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    
                    }
                    
                    {
                        user ?
                            user[0].level === 'admin' ?
                                routes === `${route}/location` ?
                                    <Location
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)} 
                                        progress={(e) => progress(e)} 
                                    />
                                : routes === `${route}/master/location/category` ?
                                    <MasterLocationCategory
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)} 
                                        progress={(e) => progress(e)} 
                                    />
                                : routes === `${route}/payment` ?
                                    <Payment
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)} 
                                        progress={(e) => progress(e)} 
                                    />
                                : 
                                    <Admin
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)} 
                                        progress={(e) => progress(e)} 
                                    />
                            : null
                        : null
                    }
                </div>
            </div>

        </>
    );
    /*--------------------------------------------------------------
    [End Render]
    ----------------------------------------------------------------*/

}

export default Screen;